import {writable} from 'svelte/store';

import {userStore} from '@js/stores/userStore';
import {fetchCollections} from '@js/actions/collectionActions';

function CollectionsStore() {
    const {subscribe, set} = writable([]);

    let _hydrated = false;
    let _hydrating = null;

    const hydrate = () => {
        if (_hydrated) return Promise.resolve();
        if (_hydrating) return _hydrating;
        if (!userStore.isConnected) return Promise.resolve();

        _hydrating = fetchCollections()
            .then((response) => {
                set((response?.collections || []).map((entry) => ({
                    ...entry,
                    id: parseInt(entry.id, 10)
                })));
                _hydrated = true;
            })
            .finally(() => {
                _hydrating = null;
            });

        return _hydrating;
    };

    const refresh = () => {
        _hydrated = false;
        return hydrate();
    };

    return {
        subscribe,
        hydrate,
        refresh
    };
}

export const collectionsStore = CollectionsStore();
